/** CoStar.Api.EnterpriseSub2.Property.FootprintType */
export var FootprintType;
(function (FootprintType) {
    FootprintType[FootprintType["Parcel"] = 1] = "Parcel";
    FootprintType[FootprintType["Structure"] = 2] = "Structure";
    FootprintType[FootprintType["PavedArea"] = 3] = "PavedArea";
    FootprintType[FootprintType["PropertyGroupBoundary"] = 4] = "PropertyGroupBoundary";
})(FootprintType || (FootprintType = {}));
